import React from "react";

// Local
import { BoxColumn, SectionContainer } from "../../styled/styled";
import OrganizationTab from "../OrganizationTab/OrganizationTab";

const Section = ({ heading, paragraph, organizations, actions, state }) => {
  return (
    <SectionContainer>
      <BoxColumn>
        {heading !== "" && <h3 style={{ marginTop: "6px" }}>{heading}</h3>}
        {paragraph.map((pgraph, i) =>
          !(pgraph === "" || pgraph === undefined) ? (
            <p key={`p${i}`}>{pgraph}</p>
          ) : null
        )}
        {organizations && (
          <OrganizationTab
            organizations={organizations}
            actions={actions}
            state={state}
          />
        )}
      </BoxColumn>
    </SectionContainer>
  );
};

export default Section;
